module.exports = __webpack_public_path__ + "img/lmb.e769d524.svg";